module.exports = __webpack_public_path__ + "static/img/SongPaMainLogo.46e68d57.png";